import { bianka, BIANKA_ACTIVITY_TYPES } from '@fiverr-private/obs';
import { Impression, Click, ClickType, ElementType } from '@fiverr-private/bianka_js';
import { getContext } from '@fiverr-private/fiverr_context';
import { BIGQUERY_BRAND_PAGE_NAME, BIGQUERY_BRAND_PAGE_NAME_V16 } from './constants';

export interface BiankaImpressionData {
    eventName: string;
    componentName: string;
    componentText?: string;
    level?: number;
    numberOfElements?: number;
    visibleThroughScroll?: boolean;
    isV16?: boolean;
}

export interface BiankaClickData {
    eventName: string;
    elementName: string;
    elementType: ElementType;
    elementText?: string;
    position?: number;
    clickType?: ClickType;
    isV16?: boolean;
}

export const sendBiankaImpression = (data: BiankaImpressionData): void => {
    const { pageCtxId } = getContext();

    bianka.reportActivity<Impression>({
        event: {
            type: data.eventName,
            page: {
                name: data.isV16 ? BIGQUERY_BRAND_PAGE_NAME_V16 : BIGQUERY_BRAND_PAGE_NAME,
                ctxId: pageCtxId,
            },
            component: {
                impId: Date.now().toString(),
                level: data.level || 1,
                isLeaf: false,
                positionInParent: 1,
                numberOfElements: data.numberOfElements || 1,
                sizeInParent: 1,
                visibleThroughScroll: data.visibleThroughScroll !== false,
                name: data.componentName,
                ...(data.componentText ? { text: data.componentText } : {}),
            },
        },
        type: BIANKA_ACTIVITY_TYPES.IMPRESSION,
    });
};

export const sendBiankaClick = (data: BiankaClickData): void => {
    const { pageCtxId } = getContext();

    bianka.reportActivity<Click>({
        event: {
            type: data.eventName,
            page: {
                name: data.isV16 ? BIGQUERY_BRAND_PAGE_NAME_V16 : BIGQUERY_BRAND_PAGE_NAME,
                ctxId: pageCtxId,
            },
            element: {
                name: data.elementName,
                type: data.elementType,
                ...(data.position ? { position: { value: data.position } } : {}),
                ...(data.elementText ? { text: { value: data.elementText } } : {}),
            },
            clickType: data.clickType || ClickType.UNSPECIFIED,
        },
        type: BIANKA_ACTIVITY_TYPES.CLICK,
    });
};
